module.exports = __webpack_public_path__ + "img/3d.9ff62ac8.png";